import React from 'react';
import PropTypes from 'prop-types';
import { Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getMoveRequestIcon, getMoveRequestTooltipText } from './utils/jobHelpers';

const MoveRequestNotice = ({ job }) => {
  // If no job or no move request, don't render anything
  if (!job || (!job.MoveRequestDateInitiated && !job.MoveRequestDateMovedUpOut)) {
    return null;
  }

  // Determine if the job has a pending move request
  const hasPendingMoveRequest = job.MoveRequestDateInitiated && !job.MoveRequestDateMovedUpOut;
  
  // Determine if the job has been moved up
  const hasBeenMoved = job.MoveRequestDateMovedUpOut;

  // Determine variant based on status
  const variant = hasPendingMoveRequest ? "info" : "success";
  
  // Format dates for display
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      // Convert SQL date format to date object
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      console.error('Error formatting date:', error);
      return dateString;
    }
  };

  // Create different tooltips based on status
  const renderTooltip = (props) => {
    if (hasPendingMoveRequest) {
      return (
        <Tooltip id="move-request-tooltip" {...props}>
          <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
            <strong>Move Request Details:</strong>
            <br />
            Request initiated: {formatDate(job.MoveRequestDateInitiated)}
            <br />
            Previous ship date: {formatDate(job.MoveRequestPrevDate)}
            <br />
            Requested new date: {job.MoveRequestRequestedDate || 'Not specified'}
            <br />
            Reason: {job.MoveRequestReasonForMove || 'Not specified'}
          </div>
        </Tooltip>
      );
    } else if (hasBeenMoved) {
      return (
        <Tooltip id="move-request-tooltip" {...props}>
          <div style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
            <strong>Move Complete:</strong>
            <br />
            Request initiated: {formatDate(job.MoveRequestDateInitiated)}
            <br />
            Previous ship date: {formatDate(job.MoveRequestPrevDate)}
            <br />
            Date moved: {formatDate(job.MoveRequestDateMovedUpOut)}
          </div>
        </Tooltip>
      );
    }
    return null;
  };

  return (
    <OverlayTrigger placement="bottom" overlay={renderTooltip}>
      <Alert variant={variant} className="mb-3 d-flex align-items-center">
        {hasPendingMoveRequest ? (
          <>
            <i className={`${getMoveRequestIcon(job)} me-2`}></i>
            <span>This job has an <strong>active move request</strong></span>
          </>
        ) : (
          <>
            <i className={`${getMoveRequestIcon(job)} me-2`}></i>
            <span>{getMoveRequestTooltipText(job)}</span>
          </>
        )}
      </Alert>
    </OverlayTrigger>
  );
};

MoveRequestNotice.propTypes = {
  job: PropTypes.object.isRequired
};

export default MoveRequestNotice;